import mifosRepository, { MifosRepository } from "./MifosRepository";

const resource = "/search";
const APPLICATION_JSON = "application/json";

export default {

    searchResources(query,resourceName,exactMatch) {
        mifosRepository.setContentType(APPLICATION_JSON);
        const queryParams = `?query=${query}&resource=${resourceName}&exactMatch=${exactMatch}`;
        return MifosRepository.get(`${resource}${queryParams}`);
    },

}
